import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import requireAuthContext from '../../authorization/requireAuthContext'
import PermissionGrantId = com.eidu.sharedlib.entity.permission.PermissionGrantId

export type DeletePermissionGrantParameters = {
  id: PermissionGrantId
}

const deletePermissionGrant = async ({ id }: DeletePermissionGrantParameters): Promise<void> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/permissions/grants/${id.toString()}`, {
    headers: { Authorization: `Bearer ${authContext.accessToken}` },
    method: 'DELETE',
  }).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from deletePermissionGrant endpoint`)
  })
}

export default deletePermissionGrant
